import { useSelector, shallowEqual } from 'react-redux'
import { selectors } from 'publisher/reducers/blogReducer'

export { selectors }

export default function useBlog(selector) {
  return useSelector(state => selector(state.blog), shallowEqual)
}